import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { selectNumberData, type NumberInfoProps } from '../../core/store/map';
import { CheckMarkIcon } from '../icons';
import * as S from './styled';

interface NumberLocationProps {
  fixed?: boolean;
  top?: number;
  formatted?: boolean;
  title?: string;
}

export const NumberLocation = ({
  fixed = false,
  top = 0,
  formatted = false,
  title,
}: NumberLocationProps) => {
  const { t } = useTranslation();
  const numberData: NumberInfoProps = useSelector(selectNumberData);
  const phoneNumber = numberData?.phone_number;
  const displayNumber =
    formatted && phoneNumber ? formatPhoneNumberIntl(phoneNumber) || phoneNumber : phoneNumber;

  return (
    <S.Wrapper $fixed={fixed} $top={top}>
      <S.NumberLocation>
        <CheckMarkIcon />
        <S.StyledSpan $bold>{title ?? t('number_located')}</S.StyledSpan>
        {displayNumber && <S.StyledSpan>{displayNumber}</S.StyledSpan>}
      </S.NumberLocation>
    </S.Wrapper>
  );
};
